import './style/agruav.scss'
import './style/public.scss'

(async()=>{
  const { Swiper,Navigation } = await import(/* webpackChunkName: "swiper" */ 'swiper')

  Swiper.use([Navigation])
  var swiper1 = new Swiper('#swiper1', {
    direction: 'horizontal', // 垂直切换选项
    // 如果需要分页器
    loop: true,
    pagination: {
      el: '.realtime-task .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.realtime-task .swiper-button-next',
      prevEl: '.realtime-task .swiper-button-prev',
    },
    on: {
      slideChangeTransitionEnd: function () {
        $('.realtime-task .swiper-text li').eq(this.realIndex).addClass('active')
        $('.realtime-task .swiper-text li').eq(this.realIndex).siblings().removeClass('active')
      }
    }
  })

  var swiper2 = new Swiper('#swiper2', {
    direction: 'horizontal', // 垂直切换选项
    // 如果需要分页器
    loop: true,
    pagination: {
      el: '.agruav-data .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.agruav-data .swiper-button-next',
      prevEl: '.agruav-data .swiper-button-prev',
    },
    on: {
      slideChangeTransitionEnd: function () {
        $('.agruav-data .swiper-text li').eq(this.realIndex).addClass('active')
        $('.agruav-data .swiper-text li').eq(this.realIndex).siblings().removeClass('active')
      }
    }
  });


  
$('.realtime-task .swiper-text li').hover(function () {
  swiper1.slideTo($(this).index() + 1, 1000, false);
  $(this).addClass('active')
  $(this).siblings().removeClass('active')
});

$('.agruav-data .swiper-text li').hover(function () {
  swiper2.slideTo($(this).index() + 1, 1000, false);
  $(this).addClass('active')
  $(this).siblings().removeClass('active')
});

})()
